export const CONCERN = {
    FETCH_CONCERN: {
        MAIN: 'FETCH_CONCERN',
        SUCCESS: 'FETCH_CONCERN_SUCCESS',
        FAILURE: 'FETCH_CONCERN_FAILURE'
    }
}
